module.exports = __webpack_public_path__ + "img/shopify-icon.731f521b.png";